export const COMBO_ES_ES = {
	placeholder: "Filtrar combos",
	addComboButton: "Agregar combo",
	activateMultipleCombosButton: "Activar múltiples combos",
	disableMultipleCombosButton: "Desactivar múltiples combos",
	activatedMultipleCombos: "Combos activados",
	activatedSingleCombo: "Combo activado",
	deactivatedMultipleCombos: "Combos desactivados",
	deactivatedSingleCombo: "Combo desactivado",
	table: {
		name: "Combo",
		warning:
			"¡Atención! Para disponibilizar este combo para venta, configure su precio al lado",
		fiscalInfo:
			"Este combo no tiene datos fiscales. Por eso, se considerarán los datos fiscales de sus productos",
		category: "Categoría",
		description: "Descripción",
		products: "Productos",
		price: "Precio",
		active: "Activo",
	},
	addComboModal: {
		errors: {
			obrigatoryField: "Este campo es obligatorio",
			invalidValue: "Valor inválido",
			products: "El combo debe estar asociado a al menos un producto",
		},
		name: "Nombre",
		category: "Categoría",
		price: "Precio",
		description: "Descripción",
		picture: "Foto:",
		products: "Productos",
		includeFiscal: "¿Incluir datos fiscales?",
		include: "Incluir",
		printComboProductsIndividually:
			"En la venta de ticket, imprimir los productos del combo individualmente",
		fiscalData: "Datos fiscales",
		fiscalFields: {
			code: "SKU",
			ncm: "NCM",
			cest: "CEST",
			fiscalGroup: "Grupo fiscal",
			fiscalProfile: "Perfil fiscal",
		},
		edit: "Editar",
		editCombo: "Editar combo",
		add: "Agregar",
		addCombo: "Agregar combo",
		cancel: "Cancelar",
	},
	deleteCombo: '¿Desea eliminar el producto "{{name}}"?',
	columns: {
		name: "Combo",
		category: "Categoría",
		description: "Descripción",
		products: "Productos",
		price: "Precio",
		active: "Activo",
	},
};
